import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Main from '@/views/Main'
import Game from '@/views/Game'
import InfoPage from '@/views/InfoPage'
import { getGameById } from '@/common/games'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },{
      path: '/hello',
      name: 'HelloWorld',
      component: HelloWorld
    }, {
      path: '/about',
      name: 'About',
      component: InfoPage,
      meta: { pageKey: 'about' }
    }, {
      path: '/contact',
      name: 'Contact',
      component: InfoPage,
      meta: { pageKey: 'contact' }
    }, {
      path: '/privacy',
      name: 'Privacy',
      component: InfoPage,
      meta: { pageKey: 'privacy' }
    }, {
      path: '/terms',
      name: 'Terms',
      component: InfoPage,
      meta: { pageKey: 'terms' }
    },{
      path: '/game',
      redirect: function (to) {
        var game = getGameById(to.query.id)

        if (!game) {
          return { name: 'Main' }
        }

        return {
          name: 'Game',
          params: { slug: game.slug }
        }
      }
    }, {
      path: '/games/:slug',
      name: 'Game',
      component: Game
    }, {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js